import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment/moment';
import { NumberTranslatePipe } from '@app/shared/pipes/number-translate.pipe';

@Pipe({
  name: 'datetimeTranslate',
  pure: false,
})
export class DatetimeTranslatePipe implements PipeTransform {
  constructor(private numberTranslatePipe: NumberTranslatePipe) {}
  transform(
    value: string | Date | undefined | null,
    args?: { format?: string; valueFormat?: string }
  ): string {
    if (value === null) {
      return '';
    }

    const formatted = moment(value, args?.valueFormat).format(args?.format);
    return this.numberTranslatePipe.translateDigitsInString(formatted);
  }
}
